import {useNavigate} from 'react-router-dom'
import {useBiStore} from '../states/bi.state'
import {useEffect} from 'react'
import {KTCard} from '../../../../_metronic/helpers'
import {LoadingComponent} from '../../apps/crm/properties-management/components/loading.component'
import ReactPaginate from 'react-paginate'
import {generateCurrencyFormat} from '../../../helpers/generate-currency-format'
import {ProjectionChart} from '../../../../_metronic/partials/widgets/charts/projections'

const SalesProjectionListComponent = () => {
  const {
    getBiSalesProjections,
    biSalesProjectionLoading,
    biSalesProjectionModel,
    biSalesProjections,
  } = useBiStore()
  const navigate = useNavigate()

  useEffect(() => {
    getBiSalesProjections({page: 0, size: 10})
  }, [])

  const handlePageClick = (e: any) => {
    const selectedPage = e.selected
    getBiSalesProjections({page: selectedPage, size: 10})
  }

  return (
    <>
      {!biSalesProjectionLoading && biSalesProjections?.length > 0 ? (
        <ProjectionChart className='card-xxl-stretch mb-5 mb-xl-10' />
      ) : null}
      <KTCard>
        <div className='card-header border-0 pt-6'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Projections</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>Projections Management</span>
          </h3>
        </div>
        <div className='card-body py-3'>
          <div className='table-responsive'>
            {biSalesProjectionLoading ? <LoadingComponent /> : <></>}
            <table className='table table-row-bordered table-striped table-hover table-row-gray-100 align-middle gs-3 gy-3'>
              <thead>
                <tr className='text-start text-muted fw-bold fs-7 text-uppercase gs-0'>
                  <th>Company Name</th>
                  <th>Total Donations</th>
                  <th>Projection</th>
                </tr>
              </thead>
              <tbody className='text-gray-600 fw-semibold'>
                {biSalesProjections?.length === 0 ? (
                  <tr>
                    <td colSpan={6}>
                      <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                        No Properties Found
                      </div>
                    </td>
                  </tr>
                ) : (
                  biSalesProjections?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.company_name}</td>
                        <td>{generateCurrencyFormat(item.total_donations)}</td>
                        <td>{generateCurrencyFormat(item.projections)}</td>
                      </tr>
                    )
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className='card-footer'>
            <ReactPaginate
              previousLabel={'«'}
              nextLabel={'»'}
              breakLabel={'...'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
              previousClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextClassName={'page-item'}
              nextLinkClassName={'page-link'}
              pageCount={biSalesProjectionModel?.data?.total_pages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={10}
              onPageChange={handlePageClick}
              containerClassName={'pagination pagination-sm m-0 float-right'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              activeClassName={'active'}
            />
          </div>
        </div>
      </KTCard>
    </>
  )
}

const SalesProjectionListWrapper = () => {
  return (
    <>
      <SalesProjectionListComponent />
    </>
  )
}

export default SalesProjectionListWrapper
